module.exports = __webpack_public_path__ + "static/media/children1.50f7ef28.jpg";